var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskScheduled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.875,
    height: 20.125,
    viewBox: "0 0 17.875 20.125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14267",
    "data-name": "Group 14267",
    transform: "translate(-3382.25 12240)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clock",
    transform: "translate(3388 -12232)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13388",
    "data-name": "Path 13388",
    d: "M8,12a4,4,0,1,1,4-4A4,4,0,0,1,8,12Zm3.2-4A3.2,3.2,0,1,0,8,11.2,3.2,3.2,0,0,0,11.2,8ZM9.6,7.6a.4.4,0,1,1,0,.8H8.4a.8.8,0,0,1-.8-.8V6a.4.4,0,1,1,.8,0V7.6Z",
    fill: "#868a97",
    stroke: "#868a97",
    strokeWidth: 0.25,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14266",
    "data-name": "Group 14266",
    transform: "translate(3382.25 -12240)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13383",
    "data-name": "Path 13383",
    d: "M25.65,6.643H23.49V5.929A1.439,1.439,0,0,0,22.05,4.5H16.29a1.439,1.439,0,0,0-1.44,1.429v.714H12.69a1.439,1.439,0,0,0-1.44,1.429v15A1.439,1.439,0,0,0,12.69,24.5h7.48V23.071H12.69v-15h2.16v2.143h8.64V8.071h2.16v6.857h1.44V8.071A1.439,1.439,0,0,0,25.65,6.643Zm-3.6,2.143H16.29V5.929h5.76Z",
    transform: "translate(-11.25 -4.5)",
    fill: "#868a97"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskScheduled);
export default __webpack_public_path__ + "static/media/taskScheduled.7cedf2ae770193de5184bee0319ce05c.svg";
export { ForwardRef as ReactComponent };